import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, catchError, of, map, filter, withLatestFrom, debounceTime } from 'rxjs';

import { LocationService } from '@offconon/core-api';

import * as CountryActions from './country.actions';
import { selectCountryList } from './country.selectors';

@Injectable()
export class CountryEffects {
  private actions$ = inject(Actions);
  private locationService = inject(LocationService);
  private store = inject(Store);

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountryActions.initCountry),
      switchMap(() => of(CountryActions.loadCountrySuccess({ country: [] }))),
      catchError((error) => {
        return of(CountryActions.loadCountryFailure({ error }));
      }),
    ),
  );

  loadCountryList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CountryActions.fetchCountryList),
      debounceTime(300),
      withLatestFrom(this.store.select(selectCountryList)),
      // eslint-disable-next-line unused-imports/no-unused-vars
      filter(([payload, countryList]) => {
        return countryList?.length === 0 || countryList?.length === undefined;
      }),
      switchMap(() =>
        this.locationService.locationCountriesList(1, 600).pipe(
          map((res) => CountryActions.updateCountryList({ countryList: res?.results || [] })),
          catchError((error) => {
            return of(CountryActions.loadCountryFailure({ error }));
          }),
        ),
      ),
    ),
  );
}
